
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.252 2.461a6.667 6.667 0 018.461.826l.034.013a6.667 6.667 0 01-7.334 10.853.84.84 0 00-.426-.06l-2.854.574H2a.667.667 0 01-.487-.194.667.667 0 01-.18-.606l.587-2.82a.707.707 0 00-.06-.427 6.667 6.667 0 012.392-8.159zm7.523 1.764a5.333 5.333 0 00-8.688 5.842c.167.379.215.8.14 1.206l-.38 1.88 1.88-.38c.123-.021.248-.032.373-.033.286.002.57.061.833.173a5.333 5.333 0 005.842-8.688zM8 7.333a.667.667 0 110 1.334.667.667 0 010-1.334zm2.667 0a.667.667 0 110 1.334.667.667 0 010-1.334zm-5.334 0a.667.667 0 110 1.334.667.667 0 010-1.334z"}})])
          )
        }
      }
    